import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentType } from '@types';
import ComponentRenderer from '@helper/ComponentRenderer/ComponentRenderer';
const UIView = ({ moduleId, componentId, additionalProps }) => {
    return (_jsx("div", { className: "uxpcore_uiview__container", children: _jsx(ComponentRenderer, { moduleId: moduleId, componentId: componentId, type: ComponentType.UI, additionalProps: additionalProps }) }));
};
export default UIView;
